import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Breadcrumb navigation component.
 *
 * @param {Array<{label: string, to?: string}>} items - Array of breadcrumb segments.
 *   Items with a `to` prop are rendered as links; the last item is plain text.
 */
const Breadcrumb = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-gray-500">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={idx} className="flex items-center gap-1">
              {idx > 0 && <ChevronRight size={14} className="text-gray-400" />}
              {isLast || !item.to ? (
                <span className={isLast ? 'font-medium text-gray-800' : ''}>{item.label}</span>
              ) : (
                <Link to={item.to} className="hover:text-teal-600 hover:underline">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
